/**
 * /tenants/$slug/provisioning/$connectionId — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchConnection, provisioningKeys } from "@/features/provisioning/queries";
import { ConnectionDetailPage } from "@/features/provisioning/pages/connection-detail-page";

export const Route = createFileRoute("/_authed/tenants/$slug/provisioning/$connectionId")({
  validateSearch: (raw: Record<string, unknown>): { removals?: "history" } => ({ removals: raw.removals === "history" ? "history" : undefined }),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: provisioningKeys.detail(context.tenant.id, params.connectionId),
      queryFn: () => fetchConnection(context.tenant.id, params.connectionId),
    }),
  component: ConnectionDetailPage,
});
